<div class="login-container">
  <alert></alert>

  <div class="content-container">

    <section class="card-login" *ngIf="!actionCompleted">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <img class="avux-logo" src="/assets/img/logo/avux-lg-green.svg" alt="Avux logo">
            <language-select></language-select>
        </div>
        <div class="d-flex align-items-center justify-content-start mt-3">
            <!-- <i class="card-icon fa-regular fa-key"></i> -->
            <span class="logon-text">{{'login.recover_password' | translate}}</span>
        </div>
      </div>

      <div class="card-body">
        <form [formGroup]="forgotpwForm" (ngSubmit)="onSubmit()">

          <div class="form-group">
            <b><label kupari-label for="username" [class]="'control-label mb-1'" [text]="'messaging.email_address'"></label></b>
            <kupari-input [icon]="'fa-light fa-envelope'" [placeholder]="'messaging.email_address'"  formControlName="username" [id]="'username'" [class]="'form-control'"></kupari-input>
          </div>

          <div class="form-group justify-content-center">
            <kupari-button [type]="'submit'" [class]="'btn btn-primary w-100 bolder-button shadow'" [text]="'login.send_recovery_link'">
            </kupari-button>
          </div>
        </form>

        <div class="text-center mb-3">
          <a class="d-block small mt-3" [routerLink]="['/login']">
            <b>{{'login.return_to_login' | translate}}</b>
          </a>
        </div>
      </div>
      <div class="card-footer">
        <app-login-footer></app-login-footer>
      </div>
    </section>

    <section class="card-login" *ngIf="actionCompleted">
      <div class="card-header">
        <div class="d-flex align-items-center justify-content-between">
          <img class="avux-logo" src="/assets/img/logo/avux-lg-green.svg" alt="Avux logo">
            <language-select></language-select>
        </div>
        <div class="d-flex align-items-center justify-content-start mt-3">
            <!-- <i class="card-icon fa-regular fa-key"></i> -->
            <span class="logon-text">{{'login.recover_success_header' | translate}}</span>
        </div>
      </div>

      <div class="card-body">
        <p>
          {{'login.recover_success' | translate: {value:f.username.value } }}
        </p>
        <div class="form-group justify-content-center">
          <a [routerLink]="['/login']" class="btn btn-primary w-100 bolder-button shadow">
            {{'login.return_to_login' | translate}}
          </a>
        </div>
      </div>
      <div class="card-footer">
        <app-login-footer></app-login-footer>
      </div>
    </section>

  </div>
  <div class="brand-image-container">
  </div>






</div>
